import React from 'react';

import Typography from '@material-ui/core/Typography';

import ToggleOnOutlinedIcon from '@material-ui/icons/ToggleOnOutlined';
import ToggleOffOutlinedIcon from '@material-ui/icons/ToggleOffOutlined';

import { getString } from '../../helpers/stringHelpers.js';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

const stringsComponent = 'app';

class ToggleButton extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes, toggleState, onToggle, showDisabled } = this.props;

    const ToggleButton = toggleState
      ? ToggleOnOutlinedIcon
      : ToggleOffOutlinedIcon;

    return (
      <div className={classes.center}>
        <div>
          <ToggleButton
            className={
              toggleState && !showDisabled
                ? classes.toggleOn
                : classes.toggleOff
            }
            onClick={onToggle}
          />
        </div>
        <div className={classes.toggleTextWrapper}>
          <a
            href="#"
            onClick={(e) => {
              onToggle();
              e.preventDefault();
            }}
          >
            <Typography
              className={
                toggleState && !showDisabled
                  ? classes.toggleTextOn
                  : classes.toggleTextOff
              }
            >
              {toggleState
                ? getString(stringsComponent, 'ON_LABEL')
                : getString(stringsComponent, 'OFF_LABEL')}
            </Typography>
          </a>
        </div>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(ToggleButton);
